<template>
  <div class="joined-member box">
    <div class="flex justify-between mb-3">
      <h3 class="text-black">可參與訂購部門</h3>
      <w-button
        v-if="hasSelectedMembers"
        color-type="error"
        size="sm"
        type="outlined"
        @click="$emit('clear')"
      >
        <span>清除名單</span>
      </w-button>
    </div>
    <div v-if="!notAllowToEditMembers" class="pb-4">
      <label v-if="onlyAllowToAddMembers" class="font-medium text-sm">
        新增訂購名單
      </label>
      <div class="mt-3">
        <span
          v-if="!hasSelectedMembers"
          class="text-gray-500 text-sm"
        >
          目前尚無新增之名單
        </span>
        <div v-else class="grid grid-cols-2 gap-3">
          <div
            v-for="(department, idx) in Object.values(departmentInfos)"
            :key="`selected-member-${department.id}`"
            class="joined-member__card"
          >
            <div class="bg-seaweed-green-500 joined-member__card--block">
              <span class="text-white text-xs">{{ idx + 1 }}</span>
              <w-button
                type="icon"
                @click.prevent="$emit('remove-selected-department', department.id)"
              >
                <i class="icon-cross text-[8px] text-white" />
              </w-button>
            </div>
            <div class="h-[52px] px-1 py-0.5 rounded-b-sm truncate">
              <span class="font-medium">{{ department.name }}({{ department.count }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="notAllowToEditMembers || onlyAllowToAddMembers"
      :class="{ 'border-dashed border-gray-50 border-t pt-4': onlyAllowToAddMembers }"
    >
      <div class="flex items-center justify-between gap-2">
        <label class="font-medium text-sm">原有訂購名單</label>
        <span
          v-if="originSelectedDescription"
          class="text-gray-500 text-xs"
        >
          {{ originSelectedDescription }}
        </span>
      </div>
      <div class="mt-3">
        <span
          v-if="!hasOriginSelectedMembers"
          class="text-gray-500 text-sm"
        >
          目前尚無新增之名單
        </span>
        <div v-else class="grid grid-cols-2 gap-3">
          <div
            v-for="(department, idx) in Object.values(originDepartmentInfos)"
            :key="`origin-member-${department.id}`"
            class="joined-member__card"
          >
            <div class="bg-gray-300 joined-member__card--block">
              <span class="text-white text-xs">{{ idx + 1 }}</span>
            </div>
            <div class="h-[52px] px-1 py-0.5 rounded-b-sm truncate">
              <span class="font-medium">{{ department.name }}({{ department.count }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JoinedMembers from './JoinedMembers';

export default JoinedMembers;
</script>

<style lang="scss" scoped>
@import 'JoinedMembers';
</style>
